export default __webpack_public_path__ + "static/media/policyDuration.4cb75a12.svg";